/**
 * EasyDataTemplate组件属性
 */
export default {
    // 模板ID
    templateId: {type: String},

    /**
     *
     * 模板配置信息
     * @default { prop: '',  modules: "", template: "", moduleInfo: ""  }
     *
     */
    templateConfig: {
        type: Object,
        default: () => {
            return {
                prop: '', // 模板属性
                modules: "", // 一级模块列表
                template: "", // 模块基础信息表
                moduleInfo: "" // 模板配置信息详细表
            }
        }
    },

    /**
     * 查询参数
     * @default {}
     */
    bizParams: {type: Object, default: () => {}},

    /**
     * 额外参数
     * @default {}
     */
    extraParams: {type: Object, default: () => {}},

    /**
     * 参数（查询参数，额外参数）
     * @default { biz: {},extra: {}}
     */
    params: {
        type: Object,
        default: () => {
            return {
                // 业务查询参数
                biz: {}, // 额外参数
                extra: {}
            }
        }
    },

    /**
     * 业务数据
     * @default {}
     */
    formData: {type: Object},

    /**
     * 只读
     * @default false
     */
    readOnly: {type: Boolean, default: false},
}
